<template>
    <div>
        <div style="padding-top: 8px">
            <ejs-tab heightAdjustMode='None'  ref="counterTable" :selecting='counterTabSelect'>
                <e-tabitems>
                    <e-tabitem :header='headerText0' :content='content0'></e-tabitem>
                    <e-tabitem :header='headerText1' :content='content1'></e-tabitem>
                    <e-tabitem :header='headerText2' :content='content2'></e-tabitem>
                </e-tabitems>
            </ejs-tab>
        </div>
        <div id="systemCounter" style="display:none;">
            <SystemCounter :gnbCounterTreeClickInfo="gnbCounterTreeClickInfo" ref="SystemCounter"></SystemCounter>
        </div>
        <div id="customCounter" style="display:none;">
            <CustomCounter :gnbCounterTreeClickInfo="gnbCounterTreeClickInfo" ref="CustomCounter"></CustomCounter>
        </div>
        <div id="threshold" style="display:none;">
            <Threshold :gnbCounterTreeClickInfo="gnbCounterTreeClickInfo" ref="Threshold"></Threshold>
        </div>
    </div>
</template>

<script>
    import SystemCounter from "./SystemCounter";
    import CustomCounter from "./CustomCounter";
    import Threshold from "./Threshold";

    export default {
        name: 'GnbPmCounterRightContent',
        props: [
            'gnbCounterTreeClickInfo'
        ],
        components: {
            SystemCounter,
            CustomCounter,
            Threshold,
        },
        data() {
            return {
                headerText0: {
                    text: this.$t('Pm.systemCounter'),
                },
                headerText1: {
                    text: this.$t('Pm.customCounter'),
                },
                headerText2: {
                    text: this.$t('Pm.threshold'),
                },
                content0: '#systemCounter',
                content1: '#customCounter',
                content2: '#threshold',
            }
        },
        methods: {
            counterTabSelect(e) {
                if (e.isSwiped) {
                    e.cancel = true;
                }
                if(e.selectingIndex == 0){
                    this.$refs.SystemCounter.$refs.SystemCounterList.getSystemCounterList();
                }else if(e.selectingIndex == 1){
                    this.$refs.CustomCounter.$refs.CustomCounterList.getCustomCounterList();
                }else if(e.selectingIndex == 2){
                    this.$refs.Threshold.$refs.ThresholdList.getThresholdListData();
                }
            }
        },
        mounted() {
        }
    };
</script>

<style>

</style>
